<div class="sp-subheader__main">
    <h3 class="sp-subheader__title">
        Datos basicos
    </h3>
    <span class="sp-subheader__separator sp-subheader__separator--v"></span>
    <div class="sp-subheader__breadcrumbs">
        <a href="#" class="sp-subheader__breadcrumbs-link">Inicio</a>
        <span class="sp-subheader__breadcrumbs-separator"></span>
        <a href="" class="sp-subheader__breadcrumbs-link">Tablero de control</a>
        <span class="sp-subheader__breadcrumbs-separator"></span>
        <a href="" class="sp-subheader__breadcrumbs-link">Mis datos básicos</a>
    </div>
</div>
